module.exports = __webpack_public_path__ + "img/palette-2_fg_en.522167e.jpg";